import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { useContext } from "react";
import { ResumenContainer, ResumenMensajes } from "../Resumen/LocalStyle";
import ResumenLista from "_+_Portal/_-_Autocheckin/components/genericos/ResumenLista/ResumenLista";
import { ResumenBotones } from "../MedicoSolicitante/localStyle";
import {
  createListaResumenLabo,
  createRuta,
  msjPacienteLabo,
  proximoPaso,
} from "../PagesFun";
import { wsPostAsignarPresenteLabo } from "_+_Portal/_-_Autocheckin/context/action/laboratorio";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";

const ResumenLabo = ({ turnoActual }) => {
  const {
    pasoDispatch,
    textosAutoCheckinState,
    turnosSeleccionadosState,
    rutaDispatch,
  } = useContext(AutocheckContext);

  const { toasterDispatch } = useContext(GlobalContext);

  const mensajeStr =
    "El turno cuenta con lo necesario para hacer la validación con tu cobertura y terminar la recepción";

  const handleVolver = () => {
    setPaso("TurnosDelDiaLabo")(pasoDispatch);
  };
  const listaTurnos = turnosSeleccionadosState.turnosSeleccionados.data;
  const turno = listaTurnos[turnoActual];
  const lista = createListaResumenLabo(turno);
  let config = localStorage.getItem("config");
  let sectorTurno = JSON.parse(config).sectorTurno;
  let msj = msjPacienteLabo(lista);
  msj =
    msj === 2
      ? textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoBien
          ?.descripcion
      : msj === 1
      ? textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoRegular
          .descripcion
      : textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoMal
          .descripcion;

  const handleContinuar = () => {
    let estado = lista[0]?.estado;
    let type = lista[0]?.id;
    if (type === 1 && !estado) {
      setPaso("ValidacionCoberturaLabo")(pasoDispatch);
    } else if (type === 2 && !estado) {
      setPaso("AbonarMP")(pasoDispatch);
    } else if (listaTurnos.length > 1 && listaTurnos[turnoActual + 1]) {
      setPaso("CierreRecepcionLabo")(pasoDispatch);
    } else if (listaTurnos.length > 1 && !listaTurnos[turnoActual + 1]) {
      setPaso("CierreRecepcionLabo")(pasoDispatch);
    } else if (listaTurnos.length === 1) {
      darPresente();
    }
  };

  const darPresente = () => {
    setPaso("Loading")(pasoDispatch);
    wsPostAsignarPresenteLabo(
      turno.idProtocolo,
      sectorTurno
    )(nextStepAsignarPresente);
  };

  const nextStepAsignarPresente = (isCorrect) => {
    if (isCorrect) {
      setPaso("TurnoRecepcionadoLabo")(pasoDispatch);
    } else {
      showToaster(
        {
          texto: "Error al asignar presente",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  return (
    <LayoutPasos
      handleClick={handleVolver}
      type={"no-circle"}
      title={"AUTO CHECK IN"}
    >
      <CardBlueHeart
        medico={turno.especialidad}
        turnoTitle={turno.especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listaTurnos.length}
      />
      <ResumenContainer
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <ResumenMensajes>
          <span
            className="resumenmensajes-titulo rb24b"
            dangerouslySetInnerHTML={{ __html: msj }}
          />
          <span className="resumenmensajes-mensaje rb18m">{mensajeStr}</span>
        </ResumenMensajes>
        <ResumenLista lista={lista} />
        <ResumenBotones>
          <button className="btn bgc-primary c-white" onClick={handleContinuar}>
            <span className="rb18m">Continuar</span>
          </button>
        </ResumenBotones>
      </ResumenContainer>
    </LayoutPasos>
  );
};

export default ResumenLabo;
